import React, { useCallback, useEffect, useState } from "react";
import { Home, BookOpen } from "lucide-react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Sidebar = ({
  isSidebarOpen,
  isSidebarCollapsed,
  isMobile,
  closeSidebar,
}) => {
  const location = { pathname: "/" };

  const sidebarClass = `
    fixed left-0 top-16 h-[calc(100vh-4rem)] bg-white shadow-lg border-r border-gray-200 z-30 transition-all duration-300 ease-in-out
    ${isMobile
      ? isSidebarOpen
        ? "translate-x-0 w-64"
        : "-translate-x-full w-64"
      : isSidebarCollapsed
      ? "w-16"
      : "w-64"
    }
  `;

  const closeSidebarHandler = useCallback(() => {
    closeSidebar();
  }, [closeSidebar]);

  return (
    <>
      {/* Mobile overlay */}
      {isMobile && isSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20"
          onClick={closeSidebarHandler}
        />
      )}
      
      <aside className={sidebarClass}>
        <ul className="py-4 space-y-1">
          <li>
            <a
              href="/"
              className={`
                flex items-center px-3 py-3 mx-2 rounded-md transition-all duration-200 ease-in-out
                ${location.pathname === "/" 
                  ? "bg-green-50 text-green-700 border-r-2 border-green-600" 
                  : "text-gray-700 hover:bg-gray-50 hover:text-green-600"
                }
                ${isSidebarCollapsed && !isMobile ? "justify-center" : ""}
              `}
              onClick={closeSidebarHandler}
            >
              <Home
                className={`
                  transition-colors duration-200
                  ${isSidebarCollapsed ? "w-6 h-6" : "w-5 h-5"}
                  ${location.pathname === "/" ? "text-green-600" : "text-gray-500"}
                `}
              />
              {(isSidebarOpen || !isSidebarCollapsed) && (
                <span className="ml-3 font-medium text-sm">Панель управления</span>
              )}
            </a>
          </li>
          {/* <li>
            <a
              href="/dashboard/courses"
              className={`
                flex items-center px-3 py-3 mx-2 rounded-md transition-all duration-200 ease-in-out
                ${location.pathname === "/dashboard/courses" 
                  ? "bg-green-50 text-green-700 border-r-2 border-green-600" 
                  : "text-gray-700 hover:bg-gray-50 hover:text-green-600"
                }
                ${isSidebarCollapsed && !isMobile ? "justify-center" : ""}
              `}
              onClick={closeSidebarHandler}
            >
              <BookOpen
                className={`
                  transition-colors duration-200
                  ${isSidebarCollapsed ? "w-6 h-6" : "w-5 h-5"}
                  ${location.pathname === "/dashboard/courses" ? "text-green-600" : "text-gray-500"}
                `}
              />
              {(isSidebarOpen || !isSidebarCollapsed) && (
                <span className="ml-3 font-medium text-sm">Курсы</span>
              )}
            </a>
          </li> */}
        </ul>
      </aside>
    </>
  );
};

export default Sidebar;